export default __webpack_public_path__ + "static/gov-incentives-bleu-752d588c29a8b629bc88cc2b729e3c59.png";